var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNzFunds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 34,
    viewBox: "0 0 182 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0409 23.4596L6.21609 0H0V33.4869H5.79352V8.90781L22.5591 33.4869H27.8331V0H22.0409V23.4596Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7875 4.61783V0H31.79V5.22421H50.1583L31.6016 28.8691V33.4869H57.9759V28.2627H39.2792L57.7875 4.61783Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7441 33.4869H67.6776V19.5415H82.0719V14.3186H67.6776V5.22421H84.7567V0H61.7441V33.4869Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.68 23.5529C100.68 27.0499 98.1367 28.9157 95.5932 28.9157C92.5316 28.9157 91.2128 27.0032 91.2128 24.0193V9.00104H85.5605V25.2321C85.5605 30.5016 88.7635 33.9999 93.9433 33.9999C97.1462 33.9999 99.2658 32.5073 100.672 30.8747V33.4869H106.324V9.00104H100.672L100.68 23.5529Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.349 8.5293C120.146 8.5293 117.932 9.97528 116.519 11.6078V9.00107H110.867V33.4869H116.519V19.1216C116.519 15.6246 119.11 13.7588 121.653 13.7588C124.762 13.7588 125.987 15.9511 125.987 18.9817V33.4869H131.639V17.3491C131.638 12.0796 128.529 8.5293 123.349 8.5293Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.611 11.6132C151.056 9.79406 148.708 8.53465 145.498 8.53465C138.576 8.53465 134.619 14.3186 134.619 21.2673C134.619 28.2161 138.576 34 145.498 34C148.701 34 151.056 32.7406 152.611 30.9214V33.4869H158.263V0H152.611V11.6132ZM152.745 22.0083C152.745 26.5328 150.108 29.097 146.622 29.097C142.524 29.097 140.312 25.9265 140.312 21.262C140.312 16.5975 142.524 13.427 146.622 13.427C150.108 13.427 152.745 15.9458 152.745 20.5623V22.0083Z",
    fill: "current"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M172.528 18.5152C169.421 17.8622 167.631 17.5357 167.631 15.7632C167.631 14.132 169.138 13.1058 171.446 13.1058C174.177 13.1058 176.532 14.3652 177.945 16.5562L181.76 13.1524C179.97 10.447 176.108 8.53461 171.774 8.53461C166.076 8.53461 162.12 11.7997 162.12 16.2763C162.12 21.5005 166.595 22.48 170.504 23.273C174.413 24.066 176.485 24.2992 176.485 26.3982C176.485 28.5892 174.271 29.4288 171.869 29.4288C168.997 29.4288 166.171 27.8429 164.71 25.4653L160.473 28.8224C162.685 32.1808 167.254 34 171.822 34C177.427 34 181.996 30.8281 181.996 25.8851C182.001 20.2877 176.725 19.4015 172.528 18.5152Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNzFunds);
export default __webpack_public_path__ + "static/media/nz-funds.27999d32d83ea6e8f0c5590cdea90a7e.svg";
export { ForwardRef as ReactComponent };